import React from 'react'
import { getCurrentSubCategory, getAdditionalDependenciesVisibility } from 'SRC/modules/categories/selectors'

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { connect as formikConnect } from 'formik'
import config from 'SRC/config/config.yaml'
// import {
// 	PriceType,
// 	BuyPrice,
// 	,
// 	PriceFromTo,
// 	ItemDelivery
// } from 'modules/ads/shared/components'
import { PriceOnRequest } from '../PriceOnRequest'
import { PriceTypeForAddons } from '../PriceTypeForAddons'
import { Rent } from '../Rent'
import { RegularPrice } from '../RegularPrice'
import { DiscountPrice } from '../DiscountPrice'
import { PriceFromTo } from '../PriceFromTo'
import { PriceType } from '../PriceType'
import { BuyPrice } from '../BuyPrice'

class Price extends React.Component {
	constructor(props) {
		super(props)

		const { formik } = props

		const { priceOnRequest } = formik.values

		if (!this.getShowPriceOnRequest() && priceOnRequest) {
			formik.setFieldValue('priceOnRequest', false)
		}
	}

	getShowPriceOnRequest = () => {
    const { hasPriceOnRequestAddon, category, formik } = this.props

		const isBuyingAd = formik.values.isBuying

		if (isBuyingAd) return false

		if (category && category.forcePriceOnRequest) {
      return true
    }

    if (category && category.allowPriceOnRequest) {
      return hasPriceOnRequestAddon
    }

    return false
  }

	getShowFromToPrice = () => {
		const { formik, hasPriceFromToAddon } = this.props
		const { priceTypeForAddons, priceOnRequest } = formik.values

		return priceTypeForAddons && !priceOnRequest &&
			Number(priceTypeForAddons) === config.adForm.adPriceTypes.fromTo.id && hasPriceFromToAddon
	}

	getShowRentPrice = () => {
		const { additionalDependenciesVisibility, formik } = this.props
		const { priceOnRequest } = formik.values

		return !priceOnRequest && additionalDependenciesVisibility && additionalDependenciesVisibility.price_period
	}

	getPriceTypeForAddonsOptions = () => {
		const { hasPriceFromToAddon } = this.props
		const { adPriceTypes } = config.adForm
		const options = [
			{
				id: `${adPriceTypes.retail.id}`,
				label: adPriceTypes.retail.title,
				value: `${adPriceTypes.retail.id}`
			}
		]
		if (hasPriceFromToAddon) {
			options.push({
				id: `${adPriceTypes.fromTo.id}`,
				label: adPriceTypes.fromTo.title,
				value: `${adPriceTypes.fromTo.id}`
			})
		}
		return options
	}

	render() {
		const { formik, formType, hasPriceFromToAddon, hasDeliveryAddon } = this.props

		const isBuyingAd = formik.values.isBuying

		const showFromToPrice = this.getShowFromToPrice() && !isBuyingAd

		const showRent = this.getShowRentPrice() && !isBuyingAd

		const { priceOnRequest, priceTypeForAddons } = formik.values

		return (
      <React.Fragment>
        {this.getShowPriceOnRequest() ? <PriceOnRequest /> : null}

        {!priceOnRequest && hasPriceFromToAddon && !showRent && !isBuyingAd
          ? (
            <PriceTypeForAddons
              options={this.getPriceTypeForAddonsOptions()}
            />
          )
          : null
        }

        {!priceOnRequest && showRent ? <Rent /> : null}

        {!priceOnRequest && !isBuyingAd && (!priceTypeForAddons || Number(priceTypeForAddons) !== config.adForm.adPriceTypes.fromTo.id) && !showRent ? (
          <>
            <RegularPrice />
            {formType !== 'addBasic' ? <DiscountPrice /> : null}
          </>
        ) : null }

        {!priceOnRequest && showFromToPrice && !showRent ? <PriceFromTo /> : null}

        {/* {hasDeliveryAddon && !showRent ? <ItemDelivery /> : null} */}

        {!priceOnRequest && !isBuyingAd ? <PriceType /> : null}

        {isBuyingAd ? <BuyPrice /> : null}
      </React.Fragment>
				
		)
	}
}

const mapStateToProps = (state) => {
	return {
		category: getCurrentSubCategory(state),
		additionalDependenciesVisibility: getAdditionalDependenciesVisibility(state)
	}
}

const enhance = compose(
	connect(mapStateToProps),
	formikConnect
)

export default enhance(Price)
